import React from "react";
import "./SearchEngineShell.css";

const FIELD_SPAN_DEFAULT = 2;

/**
 * One grid cell in the fields row. Five fields × span 2 = 10 tracks; shell grid is 10×1fr + fixed button track.
 * @param {number} span — column span (default 2)
 * @param {boolean} hidden — reserve space, hide visually
 */
export function SearchEngineField({ span = FIELD_SPAN_DEFAULT, hidden = false, children, className = "" }) {
  const s = Math.min(Math.max(1, span), 10);
  return (
    <div
      className={[
        "search-engine-shell__field",
        hidden ? "search-engine-shell__field--hidden" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={{ "--ses-span": s }}
      aria-hidden={hidden ? true : undefined}
    >
      {hidden ? null : children}
    </div>
  );
}

/**
 * Single layout layer: 10 equal columns for fields + one fixed-width column for the search button (no empty fr tracks).
 * prependRow / appendRow are outside the grid.
 */
function SearchEngineShell({
  prependRow = null,
  appendRow = null,
  buttonSlot = null,
  children,
  debug = false,
  className = "",
}) {
  return (
    <div
      className={[
        "search-engine-shell",
        debug ? "search-engine-shell--debug" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      dir="rtl"
    >
      {prependRow ? (
        <div className="search-engine-shell__prepend">{prependRow}</div>
      ) : null}

      <div className="search-engine-shell__grid">
        {children}
        <div className="search-engine-shell__button-cell">{buttonSlot}</div>
      </div>

      {appendRow ? (
        <div className="search-engine-shell__append">{appendRow}</div>
      ) : null}
    </div>
  );
}

export default SearchEngineShell;
